import React from 'react';
import classNames from 'classnames';

import './Tabs.scss';

export default function Tabs({ value, onChange, tabs, className, vertical, children }) {
  const [hover, setHover] = React.useState(null);
  const [style, setStyle] = React.useState(null);
  const lineRef = React.useRef();
  const activeRef = React.useRef();

  React.useEffect(() => {
    if (activeRef.current && lineRef.current.offsetParent) {
      const activeBox = activeRef.current.getBoundingClientRect();
      const parentBox = lineRef.current.offsetParent.getBoundingClientRect();
      const style = {};
      if (vertical) {
        style.top = activeBox.top - parentBox.top + 6;
        style.left = activeBox.right - parentBox.left;
        style.height = activeBox.bottom - activeBox.top - 12;
      } else {
        style.left = activeBox.left - parentBox.left;
        style.top = activeBox.bottom - parentBox.top;
        style.width = activeBox.right - activeBox.left;
      }
      setStyle(style);
    }
  }, [value, hover, vertical]);

  const active = (hover || value);

  return (
    <div className={classNames("ui-Tabs", className, {"ui-vertical": vertical})}>
      <ul className="ui-Tabs-header">
        {tabs.map(({id, name}) => (
          <li key={id} className={classNames("ui-Tab", {"ui-Tab-active": id === value})}
              onClick={() => onChange(id)} onMouseOver={() => setHover(id)} onMouseOut={() => setHover(null)}>
            <span ref={id === active ? activeRef : null}>{name}</span>
          </li>
        ))}
      </ul>
      <div className="ui-Tab-line" ref={lineRef} style={style}/>
      <div className="ui-Tabs-content">
        {children}
      </div>
    </div>
  );
}
